import { render, staticRenderFns } from "./RelatorioLeiloes.vue?vue&type=template&id=6f0b6d61&scoped=true&"
import script from "./RelatorioLeiloes.vue?vue&type=script&lang=js&"
export * from "./RelatorioLeiloes.vue?vue&type=script&lang=js&"
import style0 from "./RelatorioLeiloes.vue?vue&type=style&index=0&id=6f0b6d61&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f0b6d61",
  null
  
)

export default component.exports